import IcDefaultAvatar from '../../../images/icons/ic-person.svg';
import { formatNumber } from '../../../src/js/lib/number';

export const updatePodium = (
  contestants,
  filtered,
  currentPage,
  type = 'distance'
) => {
  // When the leaderboard is updated, we need to update the podium which is a static html element on the page
  if (currentPage !== 1) {
    // If the page is not 1, don't update the podium
    return;
  }

  // 300pts

  const podiumContestants = contestants
    .slice(0, 3)
    .filter((c) =>
      c.filtered
        ? type === 'distance'
          ? c.period_total_distance_in_meters > 0
          : c.points > 0
        : c.position
    );

  const podium = document.querySelector('.podium');

  const podiumPositionLabel = document.querySelector(
    '.podium__header-position-label'
  );

  if (filtered) {
    podiumPositionLabel.classList.add('hidden');
  } else {
    podiumPositionLabel.classList.remove('hidden');
  }

  if (podium) {
    podiumContestants.forEach((contestant, index) => {
      // When filtering, the position on a contestant is null and is calculated by the order. That's why we use index + 1 here when querySelector
      const podiumPosition = podium.querySelector(`.podium__${index + 1}`);
      if (podiumPosition) {
        const name = podiumPosition.querySelector('.podium__athletename');
        const pointsLabel = podiumPosition.querySelector('.podium__points');
        const avatar = podiumPosition.querySelector('.podium__avatar');
        const avatarImg = avatar.querySelector('img');

        name.innerHTML = contestant.user.name;
        name.classList.add('font-medium');

        pointsLabel.innerHTML =
          type === 'distance'
            ? `${formatNumber(
                (
                  (contestant.filtered
                    ? contestant.period_total_distance_in_meters
                    : contestant.total_distance_in_meters) / 1000
                ).toFixed(0)
              )} km`
            : `${formatNumber(contestant.points)}pts`;

        if (contestant.user.avatar) {
          // The contestant has an avatar
          if (
            avatarImg &&
            avatarImg.classList.contains('avatar__image-default')
          ) {
            // If the current avatar is an image, and it's the default avatar, we change it.
            avatarImg.src = contestant.user.avatar;

            avatarImg.classList.remove('avatar__image-default');
            avatarImg.classList.add('avatar__image');
          } else if (avatarImg) {
            // The avatar is an image, we update the src only
            avatarImg.src = contestant.user.avatar;
          } else {
            // The avatar is not an image, but a Span element. We replace it with an image
            avatar.innerHTML = ''; // Remove the text

            const img = document.createElement('img');
            img.src = contestant.user.avatar;
            img.classList.add('avatar__image');
            avatar.appendChild(img);
          }
        } else {
          // The contestant has no avatar
          let textElem = null;
          if (avatarImg) {
            // If the current avatar is an image, we change it to a Span element
            avatar.innerHTML = ''; // Remove the image

            textElem = document.createElement('span');
            textElem.innerHTML = contestant.user.avatar_text;
            textElem.classList.add('avatar__text');
            avatar.appendChild(textElem);
          } else {
            // The avatar is not an image, but a Span element. We update the text
            textElem = avatar.querySelector('span');
            textElem.innerHTML = contestant.user.avatar_text;
          }

          // Set textElem. css bg-color/text-color
          textElem.classList.remove(
            'avatar__text_theme_pink',
            'avatar__text_theme_green',
            'avatar__text_theme_blue'
          );
          textElem.classList.add(contestant.user.avatar_theme);
        }
      }
    });

    const unfilledPodiumItems = 3 - podiumContestants.length;
    for (let i = 0; i < unfilledPodiumItems; i++) {
      const podiumPosition = podium.querySelector(`.podium__${3 - i}`);
      if (podiumPosition) {
        const name = podiumPosition.querySelector('.podium__athletename');
        const pointsLabel = podiumPosition.querySelector('.podium__points');
        const avatar = podiumPosition.querySelector('.podium__avatar');
        const avatarImg = avatar.querySelector('img');

        name.innerHTML = 'Up for grabs';
        name.classList.remove('font-medium');

        pointsLabel.innerHTML = '';

        if (avatarImg) {
          // If the avatar is an image, we update the src only and set the default avatar and style
          avatarImg.src = IcDefaultAvatar;
          avatarImg.classList.remove('avatar__image');
          avatarImg.classList.add('avatar__image-default');
        } else {
          // The avatar is not an image, but a Span element. We replace it with an image using the default avatar and style
          avatar.innerHTML = ''; // Remove the text

          const img = document.createElement('img');
          img.src = IcDefaultAvatar;
          img.classList.add('avatar__image-default');
          avatar.appendChild(img);
        }
      }
    }
  }
};
